import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  LOGIN_SAP_SALVAR_BEGIN,
  LOGIN_SAP_SALVAR_SUCCESS,
  LOGIN_SAP_SALVAR_FAILURE,
  LOGIN_SAP_SALVAR_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';

export function salvar(registro = {}) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: LOGIN_SAP_SALVAR_BEGIN,
    data: registro,
  };
}

export function dismissSalvarError() {
  return {
    type: LOGIN_SAP_SALVAR_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on LOGIN_SAP_SALVAR_BEGIN actions
export function* doSalvar(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  try {
    const LoginSAPApi = new Services['LoginSAPApi']();
    res = yield LoginSAPApi.salvarLoginSap(action.data);

    //let updateAll =
    yield LoginSAPApi.updateAll({ SAP_User: res.SAP_User }, { SAP_Password: res.SAP_Password });
  } catch (err) {
    yield put({
      type: LOGIN_SAP_SALVAR_FAILURE,
      data: { error: err },
    });
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: LOGIN_SAP_SALVAR_SUCCESS,
    data: res,
  });
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchSalvar() {
  yield takeLatest(LOGIN_SAP_SALVAR_BEGIN, doSalvar);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case LOGIN_SAP_SALVAR_BEGIN:
      return {
        ...state,
        salvarPending: true,
        salvarError: null,
      };

    case LOGIN_SAP_SALVAR_SUCCESS:
      return {
        ...state,
        salvarPending: false,
        salvarError: null,
      };

    case LOGIN_SAP_SALVAR_FAILURE:
      return {
        ...state,
        salvarPending: false,
        salvarError: action.data.error,
      };

    case LOGIN_SAP_SALVAR_DISMISS_ERROR:
      return {
        ...state,
        salvarError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/login-sap/redux/salvar.js